<div class="header">
  <h2>Templates</h2>
</div>
<mat-card>
  <button mat-flat-button color="primary" routerLinkActive="router-link-active"
    [routerLink]="['/notifications','templates','create-template']">
    <mat-icon>add</mat-icon>
    Create template
  </button>
  <div class="table-container mat-elevation-z0" *ngIf="emailTemplatesList?.results.length > 0">
    <table mat-table [dataSource]="emailTemplatesList?.results" matTableResponsive class="full-width">
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef class="small-cell">
          No.
        </th>
        <td mat-cell *matCellDef="let i=index" class="small-cell">
          {{i+1+pageOffset}}
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>
          Title
        </th>
        <td mat-cell *matCellDef="let record">
          {{record.title || '-'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>
          Subject
        </th>
        <td mat-cell *matCellDef="let record">
          {{record.subject || '-'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          Acttion
        </th>
        <td mat-cell *matCellDef="let record">
          <button mat-stroked-button color="primary" routerLinkActive="router-link-active"
            [routerLink]="['/notifications','templates','edit',record.id]">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [length]="emailTemplatesList?.count" (page)="onPaginationChange($event)" [pageIndex]="pageIndex"
      [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
  </div>
</mat-card>
